<template>
  <div class="showLabelContainer">
    <BLM-h4-title v-if="title" :title="title" />
    <div class="labelContent">
      <div class="itemTitle">
        <span>{{ labelName }}:</span>
      </div>
      <div v-if="tagList.length">
        <span v-for="item in tagList" :key="item.id" class="itemLabel">{{item.name}}</span>
      </div>
      <div v-else>
        <span class="itemTitle">暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowTag',
  props: {
    title: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: '可添加标签',
    },
    tagList: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.showLabelContainer{
  .labelContent{
    display: flex;
    align-items: center;
    padding-bottom: 6px;

    .itemTitle{
      width: 100px;
      padding: 0 12px;
      word-break: keep-all;
    }
    .itemLabel{
      display: inline-block;
      margin: 0 10px 10px;
      padding: 7px 15px 7px 15px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      line-height: 15px;
      font-size: 12px;
    }
  }
}
</style>
